const initialState = {
    getFacilityListData:null,
    getFacilityListStatus:false,
    getNewFacilityListData:null,
    getNewFacilityListStatus:false,
    facilityRegStatusChange:false,
    getBaaImageStatus:false,
    getBaaImage:null,
    message: null,
    getRecordReqListData : null,
    getRecordReqStatus: false,
    finalCostStatus : false,
    finalCostDetails: null,
    assignEmpStatus : false,
    fedexTrackingStatus : false,
    fedexTrakingDetails : null,
    checkFaxstatus: false,
    checkFaxdetails: null,
    downloadRecordService:false,
    downloadRecordDetails:null,
    resendFaxStatus:false,
    resendFaxDetails:null,
    facilitySettingDetails:null,
    facilitySettingStatus:false,
    finalCostForViewDetails:null,
    finalCostForViewStatus:false,
    adminEditCostDetailsStatus:false,
    adminEditCostDetailsData:null
  };
  export default initialState;